<template>
  <div class="message-detail-box-photographer">
    <div class="box1" v-if="tempData.length">
      <div class="item">
        <dropdown-calendar-type-2
          v-model="tempData[0].date"
          :mode="tempMode"
        ></dropdown-calendar-type-2>
      </div>
      <div class="item">
        <dropdown-time-type-2
          v-model="tempData[0].reservation"
        ></dropdown-time-type-2>
      </div>
      <div class="item">
        <div class="title">Location</div>
        <div class="text">Search by</div>
      </div>
    </div>
    <transition name="fade">
      <div class="message-box" v-if="tempData.length">
        <div class="container">
          <div class="profile-image">
            <img v-imageLoading="tempData[0].userProfileImage" />
          </div>
          <div class="contents">
            <div class="author">
              Shooting with
              <span class="name" v-text="tempData[0].userName"></span>
            </div>
            <div
              class="comment"
              v-text="tempData[0].location.address.detail"
            ></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropdownCalendarType2 from '@/components/common/DropdownCalendarType2'
import DropdownTimeType2 from '@/components/common/DropdownTimeType2'
import * as types from '@/store/mutation-types'
import mixCommon from '@/mixin/common'

export default {
  mixins: [mixCommon],
  name: 'message-detail-box-photographer',
  components: {
    DropdownTimeType2,
    DropdownCalendarType2
  },
  props: {
    data: {
      default: () => [],
      type: Array
    },
    mode: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      tempData: {},
      tempMode: false
    }
  },
  created() {
    console.log('data: ', this.data)
    this.tempData = this.data
    this.tempMode = this.mode
  },
  methods: {
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData[0] })
    },
    viewMap() {
      this.$store
        .dispatch(types.SET_MODAL_GOOGLE_MAP_COMPONENT, {
          component: 'recommend',
          propData: this.tempData[0].location
        })
        .then(() => {
          this.$store.dispatch(types.SET_MODAL_COMPONENT, {
            component: 'googleMap',
            active: true,
            type: 'full'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.message-detail-box-photographer {
  /*border: 1px solid #c8c8c8;*/
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    border-top: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
        border-left: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(3) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    .container {
      height: 133px;
      display: flex;
      justify-content: stretch;
      border-left: 1px solid #c8c8c8;
      border-right: 1px solid #c8c8c8;
      border-bottom: 1px solid #c8c8c8;
      .profile-image {
        width: 131px;
        height: 131px;
        position: relative;
        img {
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 100px;
          height: 100px;
        }
      }
      .contents {
        width: 70%;
        margin: 18px 0 18px 0;
        /*border: 1px dotted red;*/
        .author {
          font-weight: 600;
        }

        .comment {
          margin: 10px 0 0 0;
          width: 700px;
          height: 71px;
          /*border: 1px solid red;*/
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .location {
          cursor: pointer;
          color: blue;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transition: opacity 0.5s;
}
</style>
